import axiosInstance from '~/utils/common-http'
import { useErrorStore } from '~/stores/ErrorStore'
import { handleApiError } from '~/services/http/ApiErrorHandler'
import { getLogoutSignal } from '~/services/auth/useLogoutService'
import type { App } from 'vue'
import type { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { getAuthCookie } from '~/utils/auth-cookie'
import { laravelEcho } from '~/boot/providers/echo'
import { getLocale } from '~/boot/plugins/i18n'

export default {
  install: (app: App): void => {
    app.config.globalProperties.$http = axiosInstance
    const $http = app.config.globalProperties.$http

    app.provide('$http', $http)

    const handleResponse = (response: AxiosResponse) => {
      useErrorStore().resetErrors()
      return response
    }

    const handleError = (error: AxiosError) => {
      handleApiError(error)
      return Promise.reject(error)
    }

    $http.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      const token = getAuthCookie()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      config.headers['X-Locale'] = getLocale()

      // Add socket ID for Laravel's toOthers() to work correctly
      const socketId = laravelEcho.socketId()
      if (socketId) {
        config.headers['X-Socket-ID'] = socketId
      }

      if (!config.signal && !config.url?.endsWith('/logout')) {
        config.signal = getLogoutSignal()
      }

      return config
    })

    $http.interceptors.response.use(handleResponse, handleError)
  },
}

export const $http = axiosInstance
